const IS_SESSION_SERVICE_ENABLED = false

function getIsSessionServiceEnabled(): boolean {
  return IS_SESSION_SERVICE_ENABLED
}

export { getIsSessionServiceEnabled }
